import { render, staticRenderFns } from "./CompetitorDetail.vue?vue&type=template&id=bf9c36b4&scoped=true"
import script from "./CompetitorDetail.vue?vue&type=script&lang=js"
export * from "./CompetitorDetail.vue?vue&type=script&lang=js"
import style0 from "./CompetitorDetail.vue?vue&type=style&index=0&id=bf9c36b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf9c36b4",
  null
  
)

export default component.exports